<template>
    <div class="property-details-favorite-action">
        <b-button
                variant="secondary"
                size="lg"
                class="btn-favorite"
                block
                @click="handleFavClick"
                :disabled="favoriteIsLoading"
        >
            <i
                    :class="[
                        isFavorite ? 'fas' : 'far',
                        favoriteIsLoading ? 'pointer-events-none' : '',
                        isLargeButton ? 'mr-4 large' : ''
                    ]"
                    class="fa-heart"
            />
            {{ isFavorite ? 'Favorited' : 'Favorite' }}
        </b-button>
    </div>
</template>

<script>
    import './PropertyDetailsFavoriteAction.scss';
    import FavoriteButtonMixin from "../../../../mixins/FavoriteButtonMixin";
    import AppResource from "@milestoneslabs/milestones-js-engine/src/Data/AppResource";

    export {PROPERTY_DETAILS_FAVORITE_ACTION} from "../../../../mixins/FavoriteButtonMixin";

    export default {
        name: "PropertyDetailsFavoriteAction",
        mixins: [FavoriteButtonMixin],
        props: {
            propertyAppResource: {
                type: AppResource,
                required: false,
            },
            isLargeButton: {
                type: Boolean,
                default: false,
            },
            favoriteStatus: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                favorite: null,
            };
        },

        watch: {
            favoriteStatus: {
                immediate: true,
                handler(value) {
                    this.favorite = value;
                }
            }
        }
    };
</script>
